// @flow
import React, { Component } from 'react';
import type { Node } from 'react';
import classNames from 'classnames';
import { Trans } from '@lingui/react';
import styled, { type StyledComponent } from 'styled-components';

import type { Untranslated } from '@rover/shared/js/types';
import { FORM_ERROR_CLASSNAME } from '@rover/react-lib/constants';
import { DSToken } from '@rover/react-lib/styles';

import Popover from '../../callouts/Popover';

export type Props = {
  placement: Popover.Placement,
  children: Node,
  message: ?Untranslated,
  className?: string,
};

type State = {
  lastMessage: Untranslated,
};

export const ErrorWrapper: StyledComponent<{}> = styled.div`
  color: ${DSToken.TEXT_COLOR_ERROR};
`;

const getClassNames = (message, className) =>
  classNames(className, {
    [FORM_ERROR_CLASSNAME]: message,
  });

export default class FormValidationError extends Component<Props, State> {
  static defaultProps = {
    placement: Popover.Placement.TOP,
    message: '',
  };

  state = {
    lastMessage: '',
  };

  componentWillReceiveProps(newProps: Props) {
    if (this.props.message !== newProps.message) {
      this.setState(() => ({ lastMessage: this.props.message || '' }));
    }
  }

  renderContent() {
    const { message } = this.props;
    const { lastMessage } = this.state;

    return (
      <ErrorWrapper>
        <Trans id={message || lastMessage} />
      </ErrorWrapper>
    );
  }

  render() {
    const { placement, children, message, className, ...other } = this.props;

    return (
      <Popover
        event={Popover.Event.NONE}
        placement={placement}
        content={this.renderContent()}
        open={!!message}
        display="block"
        className={getClassNames(message, className)}
        {...other}
      >
        {children}
      </Popover>
    );
  }
}



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/FormValidationError/FormValidationError.jsx